import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/stores/store";
Vue.use(VueRouter);

import LoginPage from "@/components/Pages/LoginPage/LoginPage";
import SelectLessonPage from "@/components/Pages/SelectLessonPage/SelectLessonPage";
import LibraryPage from "@/components/Pages/LibraryPage/LibraryPage";
import ReportCardPage from "@/components/Pages/ReportCardPage/ReportCardPage";

import CalendarPage from "@/components/Pages/CalendarPage/CalendarPage";
import ClassPage from "@/components/Pages/ClassPage/ClassPage";
import CurrentLessonPage from "@/components/Pages/ClassPage/CurrentLessonPage";
import ThemeSettingsPage from "@/components/Pages/ThemeSettingsPage/ThemeSettingsPage";
import statesEnum from "@/enums/statesEnum";

const routes = [
  {
    path: "/report-card",
    name: statesEnum.REPORT_CARD,
    component: ReportCardPage,
  },
  { path: "/library", name: statesEnum.LIBRARY, component: LibraryPage },
  { path: "/calendar", name: statesEnum.CALENDAR, component: CalendarPage },
  { path: "/login", name: statesEnum.LOGIN, component: LoginPage },
  {
    path: "/select-lesson",
    name: statesEnum.SELECT_LESSON_PAGE,
    component: SelectLessonPage,
  },
  { path: "/class", name: statesEnum.CLASS, component: ClassPage },
  {
    path: "/settings",
    name: statesEnum.SETTINGS,
    component: ThemeSettingsPage,
  },
  {
    path: "/lesson/:lessonId",
    name: statesEnum.LESSON,
    component: CurrentLessonPage,
  },
  {
    path: "*",
    redirect: "/login",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  const currentPage = to.name;
  const hasToken = store.getters["UserStore/hasToken"];
  const authorizedPages = store.getters["ConfigStore/getAuthorizedPages"];
  const isAllowPage = authorizedPages.includes(currentPage);
  const isBackToLogin = to.name === statesEnum.LOGIN;
  if (isBackToLogin && hasToken) {
    const routeAfterLogin = store.getters["ConfigStore/getRouteAfterLogin"];
    next({
      name: routeAfterLogin,
      query: to.query,
    });
  } else if (hasToken || isAllowPage) {
    next();
  } else {
    next({
      path: statesEnum.LOGIN,
      query: { routeAfterLogin: statesEnum.CLASS },
    });
  }
});
export default router;
